import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { resources, SUPPORTED_LANGUAGES } from "./catalog";
export { SUPPORTED_LANGUAGES, type AppLanguage } from "./catalog";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // English remains the fallback for unexpected server keys. The build gate
    // verifies every bundled English key in every supported locale.
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "mavinty_language",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
